/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class UpdatePolicyRequest {
    getFixupPrototypeFunction() { return UpdatePolicyRequest.fixupPrototype; }

    static newInstance(model: Partial<UpdatePolicyRequest>): UpdatePolicyRequest {
        let obj = Object.assign(new UpdatePolicyRequest(), model);
        UpdatePolicyRequest.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<UpdatePolicyRequest>): UpdatePolicyRequest {
        if (!model) return null;
        return UpdatePolicyRequest.newInstance(<UpdatePolicyRequest> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: UpdatePolicyRequest) {
        if (!obj) return;

        models.UpdatePolicyRequest.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: UpdatePolicyRequest): boolean {
        Object.setPrototypeOf(obj, UpdatePolicyRequest.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        if (this.metadata) {
            models.PolicyMetadata.fixupPrototype(this.metadata);
        }
    }

    /**
     * policy name which is unique and does not allow space or special character
     */
    name: string;

    /**
     * Display name of policy which allow space this is to mostly show on the ui
     */
    display_name: string;

    /**
     * A brief explanation of the policy.
     */
    description: string;

    /**
     * Indicates the type of policy
     */
    type: Array<string>;

    /**
     * The category will be either service or resource
     */
    category: string;

    /**
     * The policy content
     */
    content: string;

    /**
     * Flag to identify system policies
     */
    is_system_policy: boolean;

    /**
     * Metadata about policy
     */
    metadata: models.PolicyMetadata;

    /**
     * Engine type of the policy
     */
    engine_type: models.PolicyEngineType;

    /**
     * Displays the cloud associated with the policy
     */
    cloud: Array<models.CloudServiceName>;

    /**
     * Policies are classified based on the basis of the activity they perform, for example provisioning, Account Management, Utilization, etc. This value is displayed in this field
     */
    classification: string;

    /**
     * Sub classification for policy
     */
    sub_classification: string;

    /**
     * The scope of the policy: Global Scope - All users will have access to view and execute CoreStack Marketplace policies; will not have access to update/delete them, Account scope - All users under that account will have access to view and execute Only Account admins can update/delete the policies, Tenant Scope - Users with access to the specific tenant will have access to policies who can describe or execute policies. Tenant admins can only update/delete. Private Scope - User who created will only have access
     */
    scope: models.AccountScope;

    /**
     * Policy content source
     */
    content_type: models.ContentType;

    /**
     * Password or private key to access of Git repo if repo is authenticated required if the content type is git
     */
    content_password_or_key: string;

    /**
     * Username of Git repo if repo is authenticated required if the content type is git
     */
    content_username: string;

    /**
     * Git project URL when the content type is git required if the content type is git
     */
    content_url: string;

    /**
     * Root path of the policy in git repo required if the content type is git
     */
    content_path: string;

    /**
     * Severity of policy
     */
    severity: models.PolicySeverity;

}
